// extracted by mini-css-extract-plugin
export default {"containerRoot":"styles_containerRoot__E2k23"};